module.exports = __webpack_public_path__ + "static/img/20.6b507538.png";